<template>
    <v-card>
        <v-card-title>
            Nutrition
            <v-spacer></v-spacer>
            <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" v-bind:pagination.sync="pagination" v-bind:total-items="pagination.totalItems">
            <template slot="items" scope="props">  
                <td class="text-xs-center">
                   <v-avatar size="36px" slot="activator">
                      <img :src="props.item.avatar_url" alt="">
                    </v-avatar>  
                </td> 
                <td class="text-xs-right">{{ props.item.first_name }}</td>
                <td class="text-xs-right">{{ props.item.last_name }}</td>
                 <td class="text-xs-right">{{ props.item.email }}</td>
                <td class="text-xs-right"> 
                    <v-edit-dialog
                     @open="rate = props.item.rate"
                        @close="updateRate(props.item.id,props.item.rate)"
                        lazy
                         > {{ props.item.rate }} $
                        <v-text-field
                         slot="input"
                         label="Edit"
                         v-model="props.item.rate"
                         single-line
                         counter
                         :rules="[max25chars]"
                        >
                       
                    </v-text-field>
              </v-edit-dialog>  
                <td class="text-xs-right">{{ props.item.roles_view }}</td>
                 <td class="text-xs-right">{{ props.item.created }}</td>
</template>

<template slot="pageText" scope="{ pageStart, pageStop }">
     From {{ pageStart }} to {{ pageStop }}
</template>
    </v-data-table>
  </v-card>
</template>





<script>
    import {
        Api
    } from '../../../services';
    import moment from 'moment';
    import _ from 'lodash';
    export default {
        props: ['data'],
        data() {
            return {
                max25chars: (v) => v.length <= 25 || 'Input too long!',
                tmp: '',
                search: '',
                pagination: {
                    rowsPerPage: 10
                },
                headers: [{
                        text: 'Avatar',
                        align: 'left',
                        value: 'avatar_url'
                    },
                    {
                        text: 'First Name',
                        align: 'left',
                        value: 'first_name'
                    },
                    {
                        text: 'Last Name',
                        value: 'last_name'
                    },
                    {
                        text: 'E-Mail',
                        value: 'email'
                    },
                    {
                        text: 'Rate/hour',
                        value: 'rate'
                    },
                    {
                        text: 'Roles',
                        value: 'roles_view'
                    },
                    {
                        text: 'Created',
                        value: 'created'
                    }
                ],
                items: [],
                rate: 0
            }
        },
        watch: {
            data: function(newValue) {
                console.log('newValue', newValue)
                this.items = newValue.users;
                this.pagination = {
                    page: newValue.page,
                    rowsPerPage: newValue.per_page,
                    totalItems: newValue.total_entries
                }
                this.items = _.map(this.items, (item) => {
                    item.created = moment(item.created_at).format('L');
                    item.roles_view = _.join(item.roles, ', ');
                    return item
                })
            },
            pagination: function(newValue, oldValue) {
                console.log('pagination', newValue)
                if (!oldValue || (oldValue.page == newValue.page &&
                        oldValue.rowsPerPage == newValue.rowsPerPage))
                    return;
                this.$emit('change', {
                    page: newValue.page,
                    per_page: newValue.rowsPerPage
                });
            }
        },
        created() {
            console.log('this.data', this.data)
            this.items = this.data.users;
            this.items = _.map(this.items, (item) => {
                item.created = moment(item.created_at).format('L');
                item.roles_view = _.join(item.roles, ', ');
                item.weekly_capacity_view = (item.weekly_capacity / (60 * 60)).toFixed(2);
                return item
            })
        },
        methods: {
            updateRate(id, rate) {
                console.log('rate',rate);
                 this.loading = true;
                Api
                    .Users()
                    .updateRate(id,{id,rate})
                    .then(() => this.loading = false)
                    .catch(err => { console.log('ERRRR'); this.loading = false})
            }   
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Admin/Users/UsersTable.vue